import {Pipe, PipeTransform} from '@angular/core';
import {CplItem} from '../../../model/cpl-item.model';
import {ComplianceItemService} from '../../../services/compliance-item.service';
import {WeekdayDisplayPipe} from '../../../shared-compliance-items/pipes/weekday-display.pipe'
import {MonthDisplayPipe} from '../../../shared-compliance-items/pipes/month-display.pipe'
import {WeekdayIntervalDisplayPipe} from '../../../shared-compliance-items/pipes/weekday-interval-display.pipe'
import {MonthDayDisplayPipe} from '../../../shared-compliance-items/pipes/month-day-display/month-day-display.pipe'
import {UnitOfMeasure} from '../../../supervision-management/compliance-items/compliance-item/enums/unit-of-measure.enum';
import {ScheduleType} from '../../../supervision-management/compliance-items/compliance-item//enums/schedule-type.enum';
import {CompletionType} from '../../../supervision-management/compliance-items/compliance-item//enums/completion-type.enum';
import {OccurrenceType} from '../../../supervision-management/compliance-items/compliance-item//enums/occurrence-type.enum';
@Pipe({
    name: 'recurrenceSummaryFilter',
    pure: false
})
export class RecurrenceSummaryFilterPipe implements PipeTransform {

    UnitOfMeasure = UnitOfMeasure;
    ScheduleType = ScheduleType;
    CompletionType = CompletionType;
    OccurrenceType = OccurrenceType;


    constructor(
        private complianceItemService: ComplianceItemService
    ) {}

    transform(complianceItem: CplItem): string {
        let value = '';

        if(complianceItem.Recurrence !== null && complianceItem.Recurrence.RecurrencePattern !== null){
                if(complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.WEEK){
                   value += "Recurs every "+complianceItem.Recurrence.RecurrencePattern.WeekSeparationCount+" week(s)";
                   if(complianceItem.Recurrence.RecurrencePattern.Weekday !== 0)   {
                        value += " on " +new WeekdayDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.Weekday);
                   }
                }
                if(complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === 0){
                    value += "Recurs every "+complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount +" month(s)."
                }
                if(complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.DAYOFMONTH){
                    value += "Day "+complianceItem.Recurrence.RecurrencePattern.DaySeparationCount +" of every "
                        +complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount +" month(s)";
                }
                if(complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.MONTH && complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.WEEKDAYOFMONTH){
                    value += "The "+ new WeekdayIntervalDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.Weekday) +" of every "
                        +complianceItem.Recurrence.RecurrencePattern.MonthSeparationCount +" month(s)";
                }
                if(complianceItem.Recurrence.RecurrencePattern.RecurrenceType === UnitOfMeasure.YEAR){
                    value += "Recur every  "+ complianceItem.Recurrence.RecurrencePattern.YearSeparationCount +" year(s)"
                    if(complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.MONTHDATE){
                        value += " on " + new MonthDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.Month ) +" "+ complianceItem.Recurrence.RecurrencePattern.Date
                        +" through "+ new MonthDayDisplayPipe().transform(complianceItem.Recurrence.EndDate.toString());
                    }
                    if(complianceItem.Recurrence.RecurrencePattern.OccurrenceType === OccurrenceType.WEEKDAYOFMONTH){
                        value += " on the "
                        + new WeekdayIntervalDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.WeekdayInterval)  +" "
                        + new WeekdayDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.Weekday)
                        +" of " + new MonthDisplayPipe().transform(complianceItem.Recurrence.RecurrencePattern.Month )
                        +" through "+ new MonthDayDisplayPipe().transform(complianceItem.Recurrence.EndDate.toString());
                    }
                }
                value+=".";
        } else {
            value = "Not Applicable";
        }

        return value;
    }
}
